module.exports = __webpack_public_path__ + "media/signup-react/Bitmap-c1d3d512.png";